import { forwardRef, HtmlHTMLAttributes, memo, ReactNode } from "react";
import classNames from "classnames";
import { AdditionalActionDescription, AdditionalActions } from "../AdditionalActions";

import styles from "./styles.module.scss";

export type CardHeaderPropsType = HtmlHTMLAttributes<HTMLDivElement> & {
  actions?: ReactNode | ReactNode[]
  header?: ReactNode
  supportingText?: ReactNode
  divider?: boolean
  additionalActions?: AdditionalActionDescription[],
}

export const CardHeader = memo(forwardRef<HTMLDivElement, CardHeaderPropsType>((
  {
    className,
    header,
    supportingText,
    actions,
    additionalActions,
    divider,
    children,
    ...props
  }, ref) => {

  const withAdditionalActions = !!additionalActions?.length;
  return (
    <div
      {...props}
      ref={ref}
      className={classNames(
        className,
        styles.root,
        {
          [styles.divider]: divider,
          [styles.withAdditionalActions]: withAdditionalActions,
        },
      )}
    >
      <div key="headerContainer" className={styles.headerContainer}>
        {typeof header === "string" ? <h3 key={"header"}>{header}</h3> : header}
        {supportingText && <p key="supportingText" className={styles.supportingText}>{supportingText}</p>}
      </div>
      <div key="actions" className={styles.actions}>
        {actions}
      </div>
      {
        withAdditionalActions &&
        <AdditionalActions
          key="additionalActions"
          buttonProps={{
            className: styles.additionalActions
          }}
          actions={additionalActions}
        />
      }
      {children}
    </div>
  );
}));
